import { apiGet } from './http';
import {
  loadingContextPath, normalizeLoadingContext,
  type LoadingContext, type LoadingContextKind,
} from '@marcianus/shared/loading-client';

/**
 * Passos REAIS de arranque (GET /loading/context) — os mesmos que a app lean
 * mostra, porque é o mesmo backend a arrancar. Nunca lança: um splash que
 * rebenta por causa da sua própria sonda tranca a consola inteira.
 */
export async function getLoadingContext(kind: LoadingContextKind = 'boot'): Promise<LoadingContext | null> {
  try {
    return normalizeLoadingContext(await apiGet<unknown>(loadingContextPath(kind)));
  } catch {
    return null;
  }
}
